import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowLeft, Loader2 } from "lucide-react";
import "./ForgotPasswordPage.css";
import apiClient from "../../../api/apiClient";
import { useGlobalAlert } from "../../../context/AlertContext";

import surprisedDog from "../../../assets/dogLevel1.png";
import socialPawsLogo from "../../../assets/appIcon.svg";
import MobileTopBar from "../../../components/MobileTopBar";
import DesktopTopBar from "../../../components/DesktopTopBar";

const ForgotPasswordPage = ({ formDataEmail, setFormDataEmail }) => {
  const navigate = useNavigate();
  const { triggerAlert } = useGlobalAlert();

  const [isSubmitting, setIsSubmitting] = useState(false);

  // Email Validation Regex
  const validateEmail = (email) => {
    return String(email)
      .toLowerCase()
      .match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
  };

  const isEmailValid = validateEmail(formDataEmail.email);

  const handleSendCode = async () => {
    if (!isEmailValid || isSubmitting) return;

    setIsSubmitting(true);

    try {
      const response = await apiClient.post("/user/send-reset-password-otp", {
        user_email: formDataEmail.email,
      });

      if (response.data.status) {
        console.log("API Success:", response.data.data);
        navigate("/verification", { state: { email: formDataEmail.email } });
      } else {
        triggerAlert(
          response.data.message ||
            "Failed to send reset code. Please try again.",
          "error",
        );
      }
    } catch (error) {
      console.error("API Call Failed", error);
      const errorMessage =
        error.response?.data?.message ||
        "Something went wrong. Please check your connection.";
      triggerAlert(errorMessage, "error");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="fp-page-container">
      {/* Desktop Header (Hidden on Mobile) */}
      {/* <div className="fp-header fp-desktop-only">
        <button className="fp-back-btn" onClick={() => navigate(-1)}>
          <ArrowLeft size={24} color="#fff" strokeWidth={3} />
          <span>Back</span>
        </button>
      </div> */}
      <DesktopTopBar
        showBack={true}
        onBack={() => navigate(-1)}
        backColor="#fff"
        showProgress={false}
      />

      {/* Mobile Header (Hidden on Desktop) */}
      {/* <div className="fp-mobile-header fp-mobile-only">
        <button
          className="fp-back-btn fp-mobile-back-override"
          onClick={() => navigate(-1)}
        >
          <ArrowLeft size={22} color="#fff" strokeWidth={3} />
          <span>Back</span>
        </button>
        <div className="fp-header-logo">
          <img src={socialPawsLogo} alt="Social Paws" className="fp-logo-img" />
          <span>Social Paws</span>
        </div>
      </div> */}
      <MobileTopBar
        onBack={() => navigate(-1)}
        backColor="#fff"
        logoColor="#fff"
        isProtectedRoute={false}
      />

      <div className="fp-content-wrapper">
        <div className="fp-mascot-container">
          <img src={surprisedDog} alt="Surprised Dog" />
        </div>

        <h1 className="fp-title">Forgot Password?</h1>

        <p className="fp-subtitle">
          Enter your email address,
          <br />
          and we'll send you a code to reset your password.
        </p>

        <div className="fp-form-area">
          <div className="fp-input-group">
            <label>EMAIL</label>
            <input
              type="email"
              placeholder="email@example.com"
              className="fp-input-field"
              value={formDataEmail.email}
              onChange={(e) =>
                setFormDataEmail({ ...formDataEmail, email: e.target.value })
              }
            />
          </div>

          <button
            className="fp-send-btn"
            onClick={handleSendCode}
            disabled={!isEmailValid || isSubmitting}
            style={{
              opacity: isEmailValid && !isSubmitting ? 1 : 0.5,
              cursor: isEmailValid && !isSubmitting ? "pointer" : "not-allowed",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
            }}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="animate-spin" size={20} />
                SENDING...
              </>
            ) : (
              "SEND CODE"
            )}
          </button>

          <div className="fp-signup-link">
            Don't have an account?{" "}
            <span onClick={() => navigate("/onboarding")}>Sign Up Here</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
